export default __webpack_public_path__ + "static/media/tete35.1c780b5f.png";